// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Item {
    static getAttributeTypeMap() {
        return Item.attributeTypeMap;
    }
}
Item.discriminator = undefined;
Item.additionalProperties = false;
Item.attributeTypeMap = [
    {
        "name": "text",
        "baseName": "text",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=item.js.map